import { StyleSheet } from 'react-native';
import { Theme } from 'types/Styles';

const GRID = 12;

const percentToHexTransparency = {
  0: '00',
  1: '03',
  2: '05',
  3: '08',
  5: '0D',
  10: '1A',
  20: '33',
  24: '3D',
  30: '4D',
  40: '66',
  50: '80',
  60: '99',
  64: 'A3',
  70: 'B3',
  80: 'CC',
  90: 'E6',
  95: 'F2',
};

function hex(
  hexValue: string,
  opacity?: keyof typeof percentToHexTransparency,
) {
  if (opacity && percentToHexTransparency[opacity]) {
    return hexValue + percentToHexTransparency[opacity];
  }
  return hexValue;
}

export const theme = {
  buttonMargin: 8,
  opacityDisabled: 0.42,
  colors: {
    backdrop: hex('#000000', 24),

    // headerButtonBackground: hex('#ffffff', 50),
    headerButtonBackground: hex('#ffffff', 90),
    headerButtonBackgroundHover: hex('#ffffff', 50),
    headerButtonBackgroundPressed: hex('#ffffff', 95),

    background: hex('#F2F2F6'),
    background80: hex('#F2F2F6', 80),
    background50: hex('#F2F2F6', 50),
    background90: hex('#F2F2F6', 90),

    black: hex('#000000'),
    black2: hex('#000000', 2),
    black3: hex('#000000', 3),
    black5: hex('#000000', 5),
    black10: hex('#000000', 10),
    black20: hex('#000000', 20),
    black30: hex('#000000', 30),
    black80: hex('#000000', 80),

    white: hex('#ffffff'),
    white95: hex('#ffffff', 95),
    white90: hex('#ffffff', 90),
    white80: hex('#ffffff', 80),
    white50: hex('#ffffff', 50),
    white30: hex('#ffffff', 30),
    white20: hex('#ffffff', 20),

    blue: hex('#0080ff'),
    blue90: hex('#0080ff', 90),
    blue80: hex('#0080ff', 80),
    blue50: hex('#0080ff', 50),
    blue20: hex('#0080ff', 20),
    blue10: hex('#0080ff', 10),
    blue5: hex('#0080ff', 5),
    blueDark: hex('#074058'),

    red: hex('#E94362'),
    red90: hex('#E94362', 90),
    red80: hex('#E94362', 80),
    red50: hex('#E94362', 50),
    red40: hex('#E94362', 40),
    red30: hex('#E94362', 30),
    red20: hex('#E94362', 20),
    red10: hex('#E94362', 10),

    green: hex('#25c9ba'),
    green90: hex('#25c9ba', 90),
    green80: hex('#25c9ba', 80),
    green50: hex('#25c9ba', 50),
    green40: hex('#25c9ba', 40),
    green30: hex('#25c9ba', 30),
    green20: hex('#25c9ba', 20),
    green10: hex('#25c9ba', 10),

    orange: hex('#F6A310'),
    orange10: hex('#F6A310', 10),
    orange30: hex('#F6A310', 30),
    orange50: hex('#F6A310', 50),

    purple: hex('#8977d0'),

    yellow: hex('#ffcb00'),
    yellow10: hex('#ffcb00', 10),
    yellowHighlight: hex('#FFFF00', 50),

    assessmentAction: hex('#E94362', 80),
    assessmentControl: hex('#41a6e2', 80),
    checklist: hex('#8977d0', 80),
    question: hex('#c077d0', 80),

    fieldValueText: hex('#424244', 90),
    textLight: hex('#000000', 40),
    navbar: hex('#f9f9f9'),
    panelUnderlay: hex('#f2f1f6'),
    placeholder: hex('#bbbbbb'),
    textBlack64: hex('#000000', 64),
    text: hex('#000000'),

    support30: hex('#8977D1', 30),
    support: hex('#8977D1'),
  },
  grid: GRID,
  padding: GRID,
  paddingHorizontalHalf: GRID / 2,
  paddingPageVertical: GRID * 2,
  paddingVertical: GRID * 2,

  modalBorderRadius: 38,
  dialogBorderRadius: 38,
  // iOS 26 uses 24 for cards but this is too much without design changes
  cardBorderRadius: 8,
};

export const ThemeLight: Theme = {
  color: {
    textHighContrast: hex('#000000'),
    textMediumContrast: hex('#757575'),
    textPlaceholder: hex('#bbbbbb'),
  },
};

export const FontFamilyRegular = 'SFProTextRegular';
export const FontFamilyMedium = 'SFProTextMedium';
export const FontFamilySemibold = 'SFProTextSemibold';
export const FontFamilyMonoSemibold = 'SFMonoSemibold';

export const GlobalStyles = StyleSheet.create({
  invalidFieldOutline: {
    outlineWidth: 1,
    outlineStyle: 'solid',
    outlineColor: theme.colors.red,
  },
});
